import {
    createSelector,
    createStructuredSelector,
} from 'reselect';
import { Namespace } from '../../enum';
import { RootState } from '../../interface';
import { initialState } from './reducer';
import {
    selectAvailability,
    selectAvailabilityStatus,
} from '../App/selector';

const selectState = (state: RootState) => state[Namespace.LM] || initialState;

export const selectLmState = createSelector(selectState, state => state);
export const selectLmFormData = createSelector(selectState, state => state.formData);
export const selectLmResponseData = createSelector(selectState, state => state.responseData);
export const selectLmError = createSelector(selectState, state => state.lmError);

export const mapStateToProps = createStructuredSelector({
    formData: selectLmFormData,
    responseData: selectLmResponseData,
    lmError: selectLmError,
    isAvailabilityChecked: selectAvailabilityStatus,
    availability: selectAvailability,
});

/**
 * LM States by selectors
 */
export type State = ReturnType<typeof mapStateToProps>;
